var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { TotalTimeCalculator, getPeriodParts } from ".";
import { PeriodPart } from "./components";
import { observer } from "mobx-react";
var TimePeriodPicker = /** @class */ (function (_super) {
    __extends(TimePeriodPicker, _super);
    function TimePeriodPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.parts = getPeriodParts(_this.props.hasDays, _this.props.dict);
        _this.calculator = new TotalTimeCalculator(_this.parts, _this.props.onChange);
        return _this;
    }
    TimePeriodPicker.prototype.componentDidMount = function () {
        this.calculator.activate();
    };
    TimePeriodPicker.prototype.componentWillUnmount = function () {
        this.calculator.deactivate();
    };
    TimePeriodPicker.prototype.render = function () {
        var parts = this.parts.map(this.getPeriodPart);
        var mappedItems = parts.slice(1).reduce(this.partsReducer, [parts[0]]);
        return (React.createElement("div", { className: "rj-time-period-picker" }, mappedItems));
    };
    TimePeriodPicker.prototype.partsReducer = function (result, nextPeriod, index) {
        return result.concat([React.createElement("span", { key: index + "_span" }, ":"), nextPeriod]);
    };
    TimePeriodPicker.prototype.getPeriodPart = function (part, index) {
        return React.createElement(PeriodPart, { key: index + "_part", part: part });
    };
    TimePeriodPicker = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], TimePeriodPicker);
    return TimePeriodPicker;
}(React.Component));
export { TimePeriodPicker };
//# sourceMappingURL=TimePeriodPicker.js.map